var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3016 6.20595H15.968V1.5M15.6964 14.0714C14.8267 15.4219 13.5507 16.4557 12.0555 17.0209C10.5603 17.5861 8.92446 17.6531 7.38872 17.2119C5.85308 16.7708 4.4985 15.8449 3.52312 14.57C2.54773 13.2951 2.00316 11.7383 1.96965 10.1284C1.93624 8.51835 2.41558 6.94008 3.33711 5.62505C4.25874 4.31002 5.57431 3.32779 7.09035 2.82217C8.60639 2.31655 10.2431 2.31412 11.7605 2.81574C13.2778 3.31735 14.5955 4.29623 15.5205 5.60882",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.4d46bad1d4b96466eb671bd16eafb988.svg";
export { ForwardRef as ReactComponent };